export default "__VITE_ASSET__BXgeAZHm__"